/* Publish by EComposer at 2026-09-30 08:16:48*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-29zs5lu655b"]=  window.__ectimmers["ecom-29zs5lu655b"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-29zs5lu655b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-29zs5lu655b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9otnpnoliof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9otnpnoliof', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-chkghk8zytb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-chkghk8zytb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7b448f6ka6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7b448f6ka6j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p7pxk360ixa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p7pxk360ixa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6kt0xu1w6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6kt0xu1w6j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-en4k3ncb7b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-en4k3ncb7b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptozzhmgo3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptozzhmgo3q', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-71jodd0af1p"]=  window.__ectimmers["ecom-71jodd0af1p"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-71jodd0af1p"]["cch73fm0p"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-71jodd0af1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-71jodd0af1p', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-98od7az9rn"]=  window.__ectimmers["ecom-98od7az9rn"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-98od7az9rn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98od7az9rn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ovqbxble2jc"]=  window.__ectimmers["ecom-ovqbxble2jc"] || {};
if(!this.settings||!this.$el||this.isLive)return;const t=this.$el;let e=t.querySelectorAll('script:not([type="application/json"])');e.length>0&&e.forEach(function(i){let n=document.createElement("script");n.type="text/javascript",n.innerText=i.innerText,i.src&&(n.src=i.src),t.appendChild(n),i.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-ovqbxble2jc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ovqbxble2jc', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}